(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["uy-model-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('uy-model-products')) return;
  const field = 'filter.p.m.custom.model';
  const normalizeModel = value => String(value || '').normalize('NFC').trim().replace(/\s+/g, ' ').toLowerCase();
  const quote = value => '"' + String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';

  class UYModelProducts extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      this.load(this._controller.signal);
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._controller = null;
      this._resize?.disconnect();
    }
    status(value, message = '') {
      this.dataset.status = value;
      const notice = this.querySelector('[data-uy-editor-status]');
      if (notice) {
        notice.textContent = message;
        notice.hidden = !message;
      }
    }
    async request(query, model, page, signal) {
      const url = new URL(this.dataset.searchUrl, location.origin);
      if (url.origin !== location.origin) throw new Error('Nieprawidłowa domena wyszukiwania.');
      url.searchParams.set('view', 'uy-model-products');
      url.searchParams.set('q', query);
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[unavailable_products]', 'show');
      url.searchParams.set('options[prefix]', 'none');
      url.searchParams.set('page', String(page));
      if (model !== null) url.searchParams.set(field, model);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const html = await this.fetchHtml(url, signal);
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const meta = doc.querySelector('template[data-uy-model-meta]');
      const cards = doc.querySelector('template[data-uy-model-cards]');
      if (!meta || !cards) throw new Error('Brak pliku templates/search.uy-model-products.liquid lub błąd Liquid w tym pliku.');
      const data = JSON.parse(meta.content.textContent);
      if (data.version !== 2) throw new Error('Podmień oba pliki karuzeli na tę samą wersję.');
      if (data.context !== this.dataset.context || !Array.isArray(data.ids) || !Array.isArray(data.products) || !Array.isArray(data.values) || !Array.isArray(data.active)) throw new Error('Nieprawidłowe dane lub inny rynek odpowiedzi Model.');
      if (!Number.isInteger(data.total) || data.total < 0 || !Number.isInteger(data.pages) || data.pages < 0 || data.pages > 100 || data.page !== page) throw new Error('Nieprawidłowa lub zbyt duża lista wyników Model (maks. 5000 produktów).');
      if (data.products.length !== data.ids.length || data.products.some((item, i) => !item || item.id !== data.ids[i] || typeof item.model !== 'string' || typeof item.url !== 'string' || typeof item.available !== 'boolean')) throw new Error('Niepełne dane produktów Model.');
      return { data, cards: cards.content };
    }
    async fetchHtml(url, signal) {
      if (url.origin !== location.origin) throw new Error('Nieprawidłowa domena produktów.');
      const controller = new AbortController();
      const cancel = () => controller.abort();
      if (signal.aborted) cancel();
      signal.addEventListener('abort', cancel, { once: true });
      const timer = setTimeout(cancel, 15000);
      let html;
      try {
        const response = await fetch(url.href, { credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Wyszukiwanie: HTTP ' + response.status);
        if (new URL(response.url || url.href).origin !== url.origin) throw new Error('Wyszukiwanie zmieniło domenę.');
        html = await response.text();
      } finally {
        clearTimeout(timer);
        signal.removeEventListener('abort', cancel);
      }
      return html;
    }
    async resolveModel(signal) {
      // Find this exact product first, then use Shopify's canonical facet value.
      // Translated model names (including market overrides) are display text only.
      const queries = [];
      if (this.dataset.sku.trim()) queries.push('variants.sku:' + quote(this.dataset.sku));
      if (this.dataset.barcode.trim()) queries.push('variants.barcode:' + quote(this.dataset.barcode));
      if (this.dataset.title.trim()) queries.push('title:' + quote(this.dataset.title));
      for (const query of queries) {
        const { data } = await this.request(query, null, 1, signal);
        if (data.total !== 1 || data.ids.length !== 1 || data.ids[0] !== this.dataset.productId) continue;
        if (!data.filterPresent) return null;
        const values = data.values.filter(value => value.count > 0 && typeof value.value === 'string' && value.value);
        if (values.length === 1 && !values[0].value.includes(',')) return values[0].value;
        throw new Error('Model musi mieć jedną wartość. Nie grupuj różnych modeli we wspólną wartość filtra.');
      }
      return null;
    }
    async filteredItems(model, signal) {
        const items = new Map();
        let pages = 1;
        let total;
        for (let page = 1; page <= pages; page++) {
          const { data, cards } = await this.request('*', model, page, signal);
          if (!data.filterPresent) return null;
          if (data.active.length !== 1 || data.active[0] !== model) throw new Error('Filtr Model nie został zastosowany.');
          if (page === 1) { pages = data.pages; total = data.total; }
          if (data.pages !== pages || data.total !== total) throw new Error('Lista produktów zmieniła się. Odśwież podgląd.');
          const nodes = [...cards.children];
          if (nodes.length !== data.ids.length) throw new Error('Niepełne kafelki produktów. Sprawdź plik widoku wyszukiwania.');
          for (let index = 0; index < nodes.length; index++) {
            const node = nodes[index];
            if (node.dataset.productId !== data.ids[index] || !node.matches('.uy-model-products__item')) throw new Error('Niezgodne identyfikatory produktów.');
            items.set(node.dataset.productId, node);
          }
        }
        if (items.size !== total || !items.has(this.dataset.productId)) throw new Error('Niepełna grupa Model. Sprawdź indeks wyszukiwania Shopify.');
        return items;
    }
    async mapLimited(values, worker, signal) {
      const results = new Array(values.length);
      let next = 0;
      await Promise.all(Array.from({ length: Math.min(3, values.length) }, async () => {
        while (next < values.length && !signal.aborted) {
          const index = next++;
          results[index] = await worker(values[index]);
        }
      }));
      if (signal.aborted) throw new Error('Przerwano pobieranie.');
      return results;
    }
    async modelIndex(signal) {
      const preview = new URL(location.href).searchParams.get('preview_theme_id') || 'live';
      const key = 'uy-model-index-v2:' + this.dataset.searchUrl + ':' + this.dataset.context + ':' + preview;
      const expected = normalizeModel(this.dataset.model);
      const currentMatches = entries => entries.some(item => item.id === this.dataset.productId && normalizeModel(item.model) === expected);
      if (this.dataset.designMode !== 'true') {
        try {
          const cached = JSON.parse(sessionStorage.getItem(key));
          const age = Date.now() - cached.time;
          if (age >= 0 && age < 120000 && Array.isArray(cached.products) && currentMatches(cached.products)) return cached.products;
        } catch (_) { /* Storage can be unavailable; fetch a fresh index. */ }
      }
      // Only lightweight metadata, no full catalogue cards or images.
      const first = await this.request('*', null, 1, signal);
      const rest = await this.mapLimited(Array.from({ length: Math.max(0, first.data.pages - 1) }, (_, i) => i + 2), page => this.request('*', null, page, signal), signal);
      const products = new Map();
      for (const { data } of [first, ...rest]) {
        if (data.total !== first.data.total || data.pages !== first.data.pages) throw new Error('Katalog zmienił się w czasie pobierania. Odśwież stronę.');
        for (const item of data.products) products.set(item.id, item);
      }
      const entries = [...products.values()];
      if (entries.length !== first.data.total || !currentMatches(entries)) throw new Error('Niepełny indeks Model lub brak bieżącego produktu w wyszukiwaniu na tym rynku.');
      if (this.dataset.designMode !== 'true') {
        try { sessionStorage.setItem(key, JSON.stringify({ time: Date.now(), products: entries })); } catch (_) { /* Optional cache. */ }
      }
      return entries;
    }
    async localizedItems(signal) {
      const entries = await this.modelIndex(signal);
      const model = normalizeModel(this.dataset.model);
      const siblings = entries.filter(item => item.id !== this.dataset.productId && normalizeModel(item.model) === model);
      const nodes = await this.mapLimited(siblings, async item => {
        const url = new URL(item.url, location.origin);
        if (url.origin !== location.origin || !url.pathname.includes('/products/')) throw new Error('Nieprawidłowy adres produktu Model.');
        for (const key of ['_pos', '_sid', '_ss']) url.searchParams.delete(key);
        url.searchParams.set('section_id', 'uy-model-products');
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const doc = new DOMParser().parseFromString(await this.fetchHtml(url, signal), 'text/html');
        const section = doc.querySelector('uy-model-products');
        const card = section?.querySelector('template[data-uy-current-card]')?.content.firstElementChild;
        if (!section || section.dataset.context !== this.dataset.context || section.dataset.productId !== item.id || normalizeModel(section.dataset.model) !== model || !card?.matches('.uy-model-products__item') || card.dataset.productId !== item.id) throw new Error('Nie można potwierdzić karty powiązanego produktu. Sprawdź publikację i zgodność tłumaczenia Model.');
        return card;
      }, signal);
      return new Map(nodes.map(node => [node.dataset.productId, node]));
    }
    async load(signal) {
      try {
        this.querySelector('[data-uy-output]').replaceChildren();
        if (!this.dataset.model.trim()) {
          this.status('empty', 'Uzupełnij istniejące pole Model (custom.model) w tym produkcie.');
          return;
        }
        this.status('loading', 'Produkty modelu: wczytywanie…');
        const model = await this.resolveModel(signal);
        const filtered = model === null ? null : await this.filteredItems(model, signal);
        const items = filtered || await this.localizedItems(signal);
        items.delete(this.dataset.productId);
        const visible = [...items.values()].filter(node => this.dataset.showUnavailable === 'true' || node.dataset.available === 'true');
        if (signal.aborted) return;
        if (!visible.length) {
          this.status('empty', 'Ten model nie ma innych produktów pasujących do ustawień sekcji na tym rynku.');
          return;
        }
        visible.sort((a, b) => Number(b.dataset.available === 'true') - Number(a.dataset.available === 'true'));
        const frame = this.querySelector('template[data-uy-frame]').content.cloneNode(true);
        const carousel = frame.querySelector('scroll-carousel');
        for (const node of visible) {
          for (const a of node.querySelectorAll('a[href]')) {
            const link = new URL(a.getAttribute('href'), location.origin);
            if (link.origin !== location.origin || !link.pathname.includes('/products/')) throw new Error('Nieprawidłowy link do produktu na tym rynku.');
            for (const key of ['_pos', '_sid', '_ss']) link.searchParams.delete(key);
            a.href = link.pathname + link.search + link.hash;
          }
          for (const label of node.querySelectorAll('[data-uy-sold-out]')) label.textContent = this.dataset.soldOut;
          for (const img of node.querySelectorAll('img')) {
            img.loading = 'lazy';
            img.decoding = 'async';
            img.sizes = 'auto, (max-width: 699px) 50vw, (max-width: 999px) 33vw, 20vw';
          }
          carousel.append(node);
        }
        this.querySelector('[data-uy-output]').replaceChildren(frame);
        const updateControls = () => {
          const scrollable = carousel.scrollWidth > carousel.clientWidth + 2;
          this.querySelectorAll('[data-uy-control]').forEach(control => { control.hidden = !scrollable; });
        };
        this._resize?.disconnect();
        this._resize = new ResizeObserver(updateControls);
        this._resize.observe(carousel);
        requestAnimationFrame(updateControls);
        this.status('ready');
      } catch (error) {
        if (signal.aborted) return;
        this.querySelector('[data-uy-output]').replaceChildren();
        this.status('error', 'Produkty modelu: ' + error.message);
        console.warn('[UniqueYou Model]', error);
      }
    }
  }
  customElements.define('uy-model-products', UYModelProducts);
})();

  } catch(e) { console.error(e); }
})();
})();
